import { PaymentAction } from '@adyen/adyen-web/dist/types/types';

import RetryPaymentApiAdapter from '@adapters/retryApiAdapter';
import { RetryPaymentStatus } from '@types-internal';
import { MergedRetryData, RetryProcessAuthorisationResponse } from '@types-internal/RetryTypes';

export interface Dependencies {
  retryApi: RetryPaymentApiAdapter;
  retrySuccessWithData?: (retryData: MergedRetryData) => void;
  initiateRetryPaymentStart: () => void;
  initiateRetryPaymentFailure: () => void;
  initiateRetryPaymentSuccess: (
    actionObject: PaymentAction,
    paymentId: string,
    retryPaymentStatus: RetryPaymentStatus,
    authorizationId?: string,
  ) => void;
  processPaymentAuthorisationFailure: () => void;
  processPaymentAuthorisationStart: () => void;
  processPaymentAuthorisationSuccess: (
    authorisationResult: RetryProcessAuthorisationResponse,
  ) => void;
}

export const thunkDispatchWithDependencies = (dependencies: Dependencies) => {
  return (dispatchFunction: (dependencies: Dependencies) => any) => {
    return dispatchFunction(dependencies);
  };
};

export type ThunkDispatch = ReturnType<typeof thunkDispatchWithDependencies>;
